import { TRootState } from "store";
import { IDownloadsState } from "./downloads.types";

export const getDownloadsSelector = (state: TRootState): IDownloadsState => state.downloads;
